<mat-card
    class="mb-25 tagus-card"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-content>
        <a
            mat-flat-button
            class="tagus fw-semibold d-block composebtn"
            href="javascript:void(0)"
            (click)="composeMail()"
            *ngIf="(permissions_entity.modules.mail_box | permissions : permissions_entity.access.create)"
            >Compose</a
        >
        <span class="sub-title d-block muted-color fw-normal fs-14"
            >MAILBOX</span
        >
        <ul class="email-sidebar ps-0 list-unstyled mb-0">
            <ng-container *ngFor="let menus of mail_sidebar">
                <li class="position-relative">
                    <i class="{{menus?.icon}}"></i>
                    <a
                        href="javascript:void(0)"
                        (click)="loadMail(menus)"
                        class="fw-semibold position-relative d-block"
                        routerLinkActive="active"
                        [ngClass]="{'gray-color': menus.id === selected_menu.id}"
                    >
                        {{menus.menu}}
                        <span class="d-block">{{menus.count > 0 ? menus.count : ''}}</span>
                    </a>
                </li>
            </ng-container>
        </ul>
    </mat-card-content>
</mat-card>
